import { ChangeDetectionStrategy, Component, ElementRef, LOCALE_ID, OnInit, Renderer2, Signal, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from 'src/app/shared/button/button.component';
import { CDN } from 'src/app/core/constants';
import { ScrollAnimationDirective } from 'src/app/core/directives/scroll-animation.directive';
import { SeoService } from 'src/app/core/services/seo.service';
import { Router, RouterModule } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { VoiceRepositoryApi } from 'src/app/data/api/voice-repository.api';
import { AuthFacade } from 'auth';
import { isMobile } from 'src/app/core/services/utils.services';
import { LanguageService } from 'src/app/core/services/language.service';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [
    CommonModule, 
    ButtonComponent, 
    RouterModule,
    ScrollAnimationDirective],
  templateUrl: './landing-new.component.html',
  styleUrls: ['./landing-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LandingNewComponent implements OnInit {

  readonly logoSVG = `${CDN.url}logo_explorer.svg`
  readonly logoData = `${CDN.url}illus_GDPR.jpg`
  readonly logoApp = `${CDN.v3}a`
  readonly cdn = CDN
  isMobile = isMobile()
  
  currentCountry: Signal<string> = computed(() => {
    return `${this.languageService.country()?.code}`
  })
  
  header!: HTMLElement
  stats$: Observable<{num_points: number}> | undefined
  locale = inject(LOCALE_ID)

  readonly seoService = inject(SeoService)
  readonly authFacade = inject(AuthFacade)
  readonly languageService = inject(LanguageService) 
  renderer = inject(Renderer2)
  readonly #voiceRepository = inject(VoiceRepositoryApi)
  isAuthenticated = this.authFacade.isAuthenticated()

  ngOnInit() {
    // this.currentCountry = this.languageService.country()?.code
    this.findHeaderLogo()
    this.hideHeader()
    this.setSeo()
    this.stats$ = this.#voiceRepository.getStats()
  }

  private findHeaderLogo() {
    this.header = <HTMLElement>document.querySelector('.app-header')
  }

  private hideHeader() {
    if (this.header) this.renderer.addClass(this.header, 'is-transparent')
  }

  private showHeader() {
    if (this.header) this.renderer.removeClass(this.header, 'is-transparent')
  }

  private setSeo() {
    this.seoService.setTitle($localize`:@@seo.landing.title:Explorer - The leading panel of dog and cat owners`)
    this.seoService.setDescription($localize`:@@seo.landing.desc:Join Explorer, the leading panel of dog and cat owners, and participate in our 100% animal-related surveys.`)
    this.seoService.setImage($localize`:@@seo.landing.image:https://explore.yummypets.com/en/share_explorer.jpg`)
  }

  ngOnDestroy() {
    this.showHeader()
  }
}
